import { COROA_D, OURO_COROA } from '../look/coroaVip';

export function CoroaVip({ className = 'vip-coroa' }: { className?: string }) {
  return (
    <svg className={className} viewBox="-7 -6 14 11" aria-label="VIP" role="img">
      <path d={COROA_D} fill={OURO_COROA} stroke="rgba(0,0,0,.85)" strokeWidth={2} strokeLinejoin="round" />
      <rect x={-6} y={1.6} width={12} height={2.4} fill="rgba(0,0,0,.28)" />
    </svg>
  );
}
